import { queryClient, useMutation, useQuery } from '../../../hooks';

import * as adminService from '../service';
import { AdminCacheKeys } from '../consts';
import { IPaginationParams } from '../../common';

export const useAccountConnections = (params?: Partial<IPaginationParams>) => {
  const getAccountConnections = useQuery({
    queryFn: async () => adminService.getAccountConnections(params),
    queryKey: [AdminCacheKeys.GetAccountConnections, params],
  });

  const fetchAccountConnectionData = useMutation({
    mutationFn: adminService.fetchAccountConnectionData,
  });

  const deleteAccountConnection = useMutation({
    mutationFn: adminService.deleteAccountConnection,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [AdminCacheKeys.GetAccountConnections, params],
      });
    },
  });

  return {
    getAccountConnections,
    fetchAccountConnectionData,
    deleteAccountConnection,
  };
};
